import { Button, Col, Popconfirm, Row, Space, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import styled from 'styled-components';
import { User } from '../../modules/auth';
import { phoneFormatter } from '../../util/utils';
import { styledTable } from '../styled/mixin';
import Title from 'antd/lib/typography/Title';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface CollaboratorListComponentProps {
  isProjectLevel: boolean;
  collaborators: User[];
  addCollaborators: () => void;
  onDelete?: (userId: string) => void;
}
function CollaboratorListComponent({
  isProjectLevel,
  collaborators,
  addCollaborators,
  onDelete,
}: CollaboratorListComponentProps) {
  const columns: ColumnsType<User> = [
    {
      title: '이름',
      dataIndex: 'name',
      width: '20%',
    },
    // {
    //   title: '소속',
    //   dataIndex: ['myEnterprise', 'name'],
    //   width: '15%',
    // },
    {
      title: '직책',
      dataIndex: 'workPosition',
      width: '10%',
    },
    {
      title: '연락처(회사)',
      dataIndex: 'workPhone',
      width: '15%',
      render: (text: any, record: any) => <>{phoneFormatter(text, 1)}</>,
    },
    {
      title: '연락처(개인)',
      dataIndex: 'personalPhone',
      width: '15%',
      render: (text: any, record: any) => <>{phoneFormatter(text, 1)}</>,
    },
    {
      title: '이메일',
      dataIndex: 'email',
      width: '15%',
    },
    {
      title: '',
      key: 'action',
      align: 'center',
      render: (text, record, index) => (
        <Space size="small">
          {onDelete && (
            <div onClick={(e) => e.stopPropagation()}>
              <Popconfirm
                title="정말 삭제하시겠습니까?"
                onConfirm={() => onDelete('' + record.id)}
              >
                <Button size="small" className="delete-table-list-item">
                  삭제
                </Button>
              </Popconfirm>
            </div>
          )}
        </Space>
      ),
    },
  ];

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <Title level={3}>
            {isProjectLevel ? '참여직원' : '거래처 직원'} 리스트
          </Title>
        </Col>
        {isProjectLevel && (
          <Col>
            <Button
              onClick={addCollaborators}
              data-test="open-add-partner-modal-btn"
              size="small"
            >
              등록
            </Button>
          </Col>
        )}
      </Row>
      <Table<User>
        rowKey="id"
        columns={columns}
        dataSource={collaborators}
        pagination={{
          defaultPageSize: 20,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
          position: ['bottomCenter'],
        }}
      />
    </StyledDiv>
  );
}

export default CollaboratorListComponent;
